<template>
  <div class="row" style="margin-top: 30px">
    <div class="col-lg-1"></div>
    <div class="col-lg-10 card p-2 ">
      <form class="row">
        <div class="col-md-12 col-lg-12">
          <label class="form-label">انتخاب دسته بندی</label>
          <select v-model="question.categorie_id" class="form-select text-center">
            <option v-if="cat_id ==''" value="" v-html="text"></option>
            <option v-for="lists in listCat" :value="lists.id">{{ lists.title }}</option>
          </select>
        </div>
        <div class="col-md-12">
          <label class="form-label"> عنوان سوال</label>
          <input type="text" class="form-control" v-model="questions">
        </div>
        <div class="col-md-12">
          <label class="form-label">گزینه یک</label>
          <input type="text" class="form-control" v-model="question.question_one">
        </div>
        <div class="col-md-12">
          <label class="form-label">گزینه دوم</label>
          <input type="text" class="form-control" v-model="question.question_two">
        </div>
        <div class="col-md-12">
          <label class="form-label">گزینه سوم</label>
          <input type="text" class="form-control" v-model="question.question_three">
        </div>
        <div class="col-md-12">
          <label class="form-label">گزینه چهارم</label>
          <input type="text" class="form-control" v-model="question.question_four">
        </div>
        <div class="col-md-12 col-lg-12">
          <label class="form-label">پاسخ صیحیح</label>
          <select class="form-select text-center" v-model="question.answers">
            <option value="question_one"> گزینه اول</option>
            <option value="question_two"> گزینه دوم</option>
            <option value="question_three"> گزینه سوم</option>
            <option value="question_four"> گزینه چهارم</option>
          </select>
        </div>
        <div class="col-md-12 col-lg-12">
          <label class="form-label">سختی سوال</label>
          <select class="form-select text-center" v-model="question.level">
            <option value="">{{ (question.level) ? question.level : "0" }}</option>
            <option value="1"> 1</option>
            <option value="2"> 2</option>
            <option value="3"> 3</option>
          </select>
        </div>
        <div class="col-md-12">
          <br>
          <btn_loading  v-if="loading" ></btn_loading>
          <button type="button" v-elseif="loading=='false'"  class="btn btn-primary form-control" v-if="status ==='true'" @click="btn_create">ثبت
            کردن
          </button>
          <button type="button"  v-elseif="loading=='false'"  class="btn btn-danger form-control" v-else @click="btn_update"> به روز رسانی کردن
          </button>
        </div>
      </form>
    </div>
    <div class="col-lg-1"></div>
  </div>
  <div class="row" style="margin-top: 30px">
    <div class="col-lg-1"></div>
    <div class="col-lg-10 card ">
      <div class="p-2 flex-fill bd-highlight col-md-12">
        <section class="mypanel">
          <div class="list-group">
            <h5 class="question">سوال </h5>
            <h6 class="title"><span style="color:red">*</span>{{ questions }}</h6>
            <label class="list-group-item list2">
              <div class="justify-content-start">
                <span> 1. </span>
                <input class="form-check-input me-1" type="radio" name="question_one">
                <span>{{ question.question_one }}</span>
              </div>
            </label>
            <label class="list-group-item list2">
              <span> 2.</span>
              <input class="form-check-input me-1" type="radio" value="" name="question_two">
              <span>{{ question.question_two }}</span>
            </label>
            <label class="list-group-item list2">
              <span>3.</span>
              <input class="form-check-input me-1" type="radio" value="" name="question_two">
              <span>{{ question.question_three }}</span>
            </label>
            <label class="list-group-item list2">
              <span>4.</span>
              <input class="form-check-input me-1" type="radio" value="" name="question_two">
              <span>{{ question.question_four }}</span>
            </label>
          </div>
        </section>
      </div>
    </div>
    <div class="col-lg-1"></div>
  </div>
</template>
<script>
import {useToast} from "vue-toastification";
import config from "../../../../config/config.json";
import {list} from "postcss";
import Btn_loading from "@/common/components/btn_loading.vue";
import axios from "axios";

export default {
  name: "index",
  components: {Btn_loading},
  computed: {
    list() {
      return list
    }
  },
  data() {
    return {
      loading:false,
      listCat: {},
      text: "لطفا دسته بندی را انتخاب کنید",
      cat_id: '',
      status: 'true',
      questions: '',
      question: {
        id: '',
        question_one: '',
        question_two: '',
        question_three: '',
        question_four: '',
        answers: '',
        level: '',
        categorie_id: ''
      },
      editQuestion: ""
    }
  },
  created() {
    this.getCat();
    this.getQuestion(this.$route.params.codeId)
  },
  methods: {
    getCat: function () {
      let self = this;
      axios.get('/categories/lists')
          .then(function (res) {
            self.listCat = res.data.data;
          })
          .catch(function (errors) {
            console.log(errors);
          });
    },
    getQuestion(id = "") {
      let self = this;
      if (id === 'create') return false;
      self.status = false;
      self.axios.get(config.BASE_URL + '/Experiments/edit/' + id)
          .then(function (res) {
            if (res.data.status) {
              let result = res.data.data;
              self.questions = result.question
              self.question.question_one = result.question_one
              self.question.question_two = result.question_two
              self.question.question_three = result.question_three
              self.question.question_four = result.question_four
              self.question.answers = result.answers
              self.question.level = result.level
              self.level = result.level
              self.question.id = id
              self.cat_id = result.categorie_id;
            }
          })
    },
    btn_create: function () {
      let self = this;
      self.loading=true;
      const toast = useToast();
      let formData = new FormData();
      formData.append('categorie_id', self.question.categorie_id);
      formData.append('question_one', self.question.question_one);
      formData.append('question_two', self.question.question_two);
      formData.append('question_three', self.question.question_three);
      formData.append('question_four', self.question.question_four);
      formData.append('level', self.question.level);
      formData.append('question', self.questions);
      formData.append('answers', self.question.answers);
      self.axios.post(config.BASE_URL + '/Experiments/create', formData).then(function (res) {
        if (res.data.status === 'true') {
          self.loading=false;
          toast.success(res.data.messages);
          return self.$router.push({path: '/panel/listQuestions'});
        }
      })
          .catch(function (errors) {
            self.loading=false;
            if (errors.response.status === 422) {
              Object.values(errors.response.data.errors).forEach(function (val, key) {
                toast.error(val[0]);
              });
            }
            if (errors.response.status === 404) {
              toast.error(errors.response.data.messages);
            }
          });
    },

    btn_update: function () {
      let self = this;
      self.loading=true;
      const toast = useToast();
      let formData = new FormData();
      formData.append('categorie_id', self.question.categorie_id);
      formData.append('id', self.question.id);
      formData.append('question_one', self.question.question_one);
      formData.append('question_two', self.question.question_two);
      formData.append('question_three', self.question.question_three);
      formData.append('question_four', self.question.question_four);
      formData.append('level', self.question.level);
      formData.append('question', self.questions);
      formData.append('answers', self.question.answers);
      self.axios.post(config.BASE_URL + '/Experiments/update', formData).then(function (res) {
        self.loading=false;
        if (res.data.status === 'true') {
          toast.success(res.data.messages);
          return self.$router.push({path: '/panel/listQuestions'});
        }
      })
          .catch(function (errors) {
            self.loading=false;
            if (errors.response.status === 422) {
              Object.values(errors.response.data.errors).forEach(function (val, key) {
                toast.error(val[0]);
              });
            }
            if (errors.response.status === 404) {
              toast.error(errors.response.data.messages);
            }
          });
    },

  }
}
</script>

<style scoped>

</style>